export default __webpack_public_path__ + "static/media/_800X800.a026b075.svg";